import {
  IGNORED_ERRORS,
  isTelemetryActive,
  scrubEvent,
  TRACES_SAMPLE_RATE,
} from "@bezbolisno/kit/telemetry";
import * as Sentry from "@sentry/react";
import { env } from "./env";

/**
 * Browser telemetry, imported first in `main.tsx`. Production only, by code (a DSN alone never
 * opens a socket), no Session Replay — the screens show clinical notes and a replay is a
 * recording of them. Same scrub policy as every other tier.
 */
export const telemetryActive = isTelemetryActive(env.VITE_SENTRY_DSN, env.VITE_SENTRY_ENVIRONMENT);

if (telemetryActive) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    release: env.VITE_SENTRY_RELEASE,
    tracesSampleRate: TRACES_SAMPLE_RATE,
    // The browser SDK has no sendDefaultPii; `beforeSend` is what keeps data out either way.
    beforeSend: (event) => scrubEvent(event),
    ignoreErrors: IGNORED_ERRORS,
  });
}

/** Report a caught failure (the route boundaries) and hand back an id the user can quote. */
export function reportError(error: unknown, context: Record<string, unknown> = {}): string | null {
  if (!telemetryActive) return null;
  return Sentry.captureException(error, { extra: context });
}
